const typography = {
  fontFamily: `"Raleway", sans-serif`,

  h1: {
    fontFamily: `"Raleway", sans-serif`,
    fontSize: "3.5rem",
    fontWeight: 500,
    letterSpacing: "0.05em",
  },

  h2: {
    fontFamily: `"Raleway", sans-serif`,
    fontSize: "2.6rem",
  },

  body1: {
    lineHeight: 1.8,
  },

  button: {
    textTransform: "uppercase",
    letterSpacing: "0.15em",
  },
};

export default typography;
